import { Component, OnInit, Input } from '@angular/core';
import { HomeService } from 'src/app/core/http/web/home.service';
import { environment as params } from 'src/environments/environment';

@Component({
  selector: 'app-slide-text',
  templateUrl: './slide-text.component.html',
  styleUrls: ['./slide-text.component.scss']
})
export class SlideTextComponent implements OnInit {
  slickOptions: any = {
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    dots: true,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };
  objectKeys = Object.keys;
  objectValues = Object.values;
  urlBaseS3: any = (<any>params).api.s3;
  // public advantages: any;
  public errors: any = null;
  public loadings: any = true;
  // public products: any;
  @Input('route') public route: string;
  @Input('load_serv') public load_serv: boolean = true;
  @Input('data') public advantages: any = null;
  constructor(
    private _homeService: HomeService
  ) { }

  ngOnInit() {
    if (this.load_serv) {
      this.getAdvantages();
    }
  }

  getAdvantages() {
    this._homeService.getAdvantages(this.route).subscribe(data => {
      this.advantages = data.ventajas;
      console.log('Ventajas data: ', this.advantages);
      // this.products = this.advantages.productos;
      if (!(data.ventajas && data.ventajas.productos && Object.values(data.ventajas.productos).length > 0)) {
        console.warn('Sin ventajas para mostrar');
        this.loadings = false;
      }
    }, err => {
      console.error(err);
      this.errors = err;
    });
  }

  reload() {
    this.loadings = true;
    this.getAdvantages();
  }

}
